import { Box, Icon, Tag, Text } from '@factorialco/deprecated-design-system'
import { Reorder, motion } from 'framer-motion'

import { type FormCompetencyLevel } from '.'
import * as style from './index.vanilla.css'

export const ReorderLevelsComponent = ({
  levels,
  onReorder,
}: {
  levels: FormCompetencyLevel[]
  onReorder: (updatedContent: FormCompetencyLevel[]) => void
}) => {
  return (
    <Box gap="s24" maxHeight="s600" overflowY="auto" overflowX="hidden" paddingRight="s4" flexGrow>
      <Reorder.Group values={levels} onReorder={onReorder}>
        <Box gap="s8">
          {levels.map((item) => (
            <Reorder.Item key={item.id} value={item}>
              <motion.div layout>
                <Box
                  className={style.card}
                  background="neutralBackground"
                  width="full"
                  border={{ all: { color: 'grey400', width: 's1', style: 'solid' } }}
                  borderRadius={{ all: 'abs008' }}
                  flexDirection="row"
                  alignItems="center"
                  position="relative"
                  paddingY="s16"
                  paddingLeft={'s4'}
                  paddingRight="s32"
                  gap="s4"
                  aria-label="competencies_v3.levels.title_singular"
                >
                  <Box className={style.dragIcon}>
                    <Icon.Medium icon="drag-and-drop" color="grey800" />
                  </Box>

                  <Box flexDirection="row" gap="s16" alignItems="center" flexGrow>
                    <Tag type="viridian">{item.position}</Tag>
                    <Text.Normal ellipsis weight="medium" lineClamp={2} overflowWrap>
                      {item.name}
                    </Text.Normal>
                  </Box>
                </Box>
              </motion.div>
            </Reorder.Item>
          ))}
        </Box>
      </Reorder.Group>
    </Box>
  )
}
